/**
 * Tiny hand-rolled search-param parsers. These are used by route
 * `validateSearch`, which lives in the shared client chunk — using zod here
 * would pull the whole ~128KB validation library into every page load.
 */

/** Highest page number that listBlogPosts accepts. */
export const MAX_LIST_PAGE = 500;

export type PageSearch = { page?: number; s?: string; category?: string };

export function parsePageSearch(search: Record<string, unknown>): PageSearch {
  const raw = search["page"];
  // Every key is set, to undefined when the value is not valid. The root route
  // passes the raw search down, and a key left out kept its raw value: on
  // 1 Oct 2026 /hair-loss-blog/?page=abc and ?page=999 reached listBlogPosts
  // as "abc" and 999, its input check threw, and the page answered 500.
  const out: PageSearch = { page: undefined, s: undefined, category: undefined };
  if (raw !== undefined && raw !== null && raw !== "") {
    const n = Number(raw);
    // Any whole number passes. A route answers 404 for a page past the last
    // one, also above MAX_LIST_PAGE. The Worker 301s other values away.
    if (Number.isInteger(n) && n >= 1) out.page = n;
  }
  const s = search["s"];
  if (typeof s === "string" && s.trim().length > 0) {
    out.s = s.trim().slice(0, 100);
  }
  const category = search["category"];
  if (typeof category === "string" && category.trim().length > 0) {
    out.category = category.trim().slice(0, 200);
  }
  return out;
}

export type RedirectSearch = { redirect?: string };

export function parseRedirectSearch(search: Record<string, unknown>): RedirectSearch {
  const raw = search["redirect"];
  return typeof raw === "string" ? { redirect: raw } : {};
}
